<div class="modal-header bg-dark">
    <h4 class="modal-title">Visualizzazione <strong>Prenotazioni</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<form #inspectionAssignForm="ngForm" role="form" class="form-horizontal form-validation">
    <div class="modal-body row">
        <div class="col-md-8 col-md-offset-2">
            <div class="table-responsive">
                <table *ngIf="reservations.length > 0" class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width: 50%;">Ispettore</th>
                            <th style="width: 40%;">Inserita il</th>
                            <th class="text-right" style="width: 10%;">Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                            <tr *ngFor="let reservation of reservations">
                                <td>{{ reservation.user.name + ' ' + reservation.user.surname }}</td>
                                <td>{{ reservation.date | date: 'dd/MM/yyyy HH:mm' }}</td>
                                <td class="text-right"><mat-radio-button [value]="reservation.user.id_user" (click)="userSelected = reservation.user"></mat-radio-button></td>
                            </tr>
                    </tbody>
                </table>
                <div *ngIf="reservations.length === 0"
                     style="text-align: center; padding: 50px 0;"><h4>Nessuna prenotazione inserita</h4></div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit"
                [disabled]="!inspectionAssignForm.form.valid"
                class="btn btn-embossed btn-primary"
                (click)="passBack()">
            <i class="icons-office-01"></i> Assegna Ispezione
        </button>
        <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
    </div>
</form>
